import getLocalString from "constants/Localization";
import { useRestoreOrganizationUserMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useRestoreOrganizationUser() {
  const [mutation, { loading, data, error }] = useRestoreOrganizationUserMutation({
    refetchQueries: ["customGetOrganizationUsers", "getOrganizationUsers"],
  });

  const [restoreOrganizationUser, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "restoreOrganizationUser",
    },
    {
      successMessage: getLocalString("organization.restore-user-success"),
      failureMessage: getLocalString("organization.restore-user-failure"),
      showValidationErrors: true,
      showGraphQLErrorMessages: true,
    }
  );

  return [restoreOrganizationUser, context] as const;
}
